import { useMutation } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { toast } from "sonner";

export interface CalendarTokenResponse {
  token: string;
  url: string;
}

/**
 * Returns a mutation that gets-or-creates a calendar feed token.
 * The caller is responsible for displaying the URL and handling copy.
 */
export function useCalendarFeedUrl() {
  return useMutation({
    mutationFn: async () => {
      const res = await apiFetch("/api/calendar/token", {
        method: "POST",
      });
      if (!res.ok) throw new Error("Failed to generate calendar URL");
      return (await res.json()) as CalendarTokenResponse;
    },
    onError: (error) => {
      toast.error(
        "Failed to generate calendar URL: " +
          (error instanceof Error ? error.message : String(error)),
      );
    },
  });
}
